import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './SplashScreen.css';

const SplashScreen = ({ onComplete }) => {
  const [isClicked, setIsClicked] = useState(false);
  // Главное фото для splash screen - полностью независимо от галереи
  // Загружается напрямую из статического файла в public папке
  const fallbackImage = "/images/main-photo.jpg";
  const [imageError, setImageError] = useState(false);

  const handleClick = () => {
    setIsClicked(true);
    // Даем время на анимацию растворения перед показом основного контента
    setTimeout(() => {
      onComplete();
    }, 800);
  };

  return (
    <AnimatePresence>
      <motion.div
        className="splash-screen"
        initial={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          className="splash-background"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        />

        <motion.div
          className="splash-content"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ 
            opacity: isClicked ? 0 : 1, 
            scale: isClicked ? 1.2 : 1 
          }}
          transition={{ 
            duration: 0.8,
            ease: "easeInOut"
          }}
          onClick={handleClick}
          style={{ cursor: 'pointer' }}
        >
          {/* Текст "Sergey Levitskiy" сверху фото */}
          {!isClicked && (
            <motion.h1
              className="splash-title"
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ 
                delay: 0.5,
                duration: 1,
                ease: "easeOut"
              }}
            >
              Sergey Levitskiy
            </motion.h1>
          )}

          {!imageError ? (
            <motion.img
              src={fallbackImage}
              alt="Sergey Levitskiy"
              className="splash-image"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ 
                opacity: isClicked ? 0 : 1,
                scale: isClicked ? 1.3 : 1,
                filter: isClicked ? 'blur(20px)' : 'blur(0px)'
              }}
              transition={{ 
                duration: 0.8,
                ease: "easeInOut"
              }}
              onLoad={() => {
                console.log('✅ SplashScreen: Фото успешно загружено:', fallbackImage);
              }}
              onError={(e) => {
                console.error('❌ SplashScreen: Ошибка загрузки фото:', e.target.src);
                // Если фото не загрузилось, показываем placeholder
                setImageError(true);
              }}
            />
          ) : (
            <motion.div
              className="splash-placeholder"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ 
                opacity: isClicked ? 0 : 1,
                scale: isClicked ? 1.3 : 1,
                filter: isClicked ? 'blur(20px)' : 'blur(0px)'
              }}
              transition={{ 
                duration: 0.8,
                ease: "easeInOut"
              }}
            >
              SL
            </motion.div>
          )}
          
          {!isClicked && (
            <motion.div
              className="splash-hint"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.5, duration: 0.5 }}
            >
              <p>Click to enter</p>
            </motion.div>
          )}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default SplashScreen;

